export default {
  header: 'Annual Report',
  select: 'Select any report'
};
